import { render, staticRenderFns } from "./KingKong.vue?vue&type=template&id=504f11d0&scoped=true&"
import script from "./KingKong.vue?vue&type=script&lang=js&"
export * from "./KingKong.vue?vue&type=script&lang=js&"
import style0 from "./KingKong.vue?vue&type=style&index=0&id=504f11d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f11d0",
  null
  
)

export default component.exports